
const initialState = {
  all_employee:[],
 
};

const DocumentApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LODING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_EMPLOYEE_FOR_DOCUMENTS_SUCCESS":
      return {
        ...state,
        all_employee: action.payload,
        error: null
      };
    case "GET_EMPLOYEE_FOR_DOCUMENTS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    
     case "GET_INTERNSHIP_LETTER_SUCCESS":
        return {
          ...state,
          error: null
        };
      case "GET_INTERNSHIP_LETTER_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };

        case "GET_RELIEVING_LETTER_SUCCESS":
        return {
          ...state,
          error: null
        };
      case "GET_RELIEVING_LETTER_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };


        case "GET_EXPERIANCE_LETTER_SUCCESS":
        return {
          ...state,
          error: null
        };
      case "GET_EXPERIANCE_LETTER_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
    
    default:
      return state;
  }
};

export default DocumentApiReducer;
